<template>
  <!--弹窗-->
  <div class="popup"
    ref="popup">
    <div class="popup-mask"
      @click="closePopup"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'popup',
  methods: {
    closePopup () {
      this.$refs.popup.classList.remove('active')
    }
  }
}
</script>

<style lang="less" scoped>
/*弹窗*/
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s;

  &.active {
    opacity: 1;
    pointer-events: auto;
  }
  .popup-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .popup-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
